import React from 'react';
import { Link } from 'react-router-dom';
import { useModalDisclosure } from '@hooks/session';
import {
  Box,
  Tag,
  Card,
  Text,
  Alert,
  Button,
  CardBody,
  EditIcon,
  AlertIcon,
} from 'ui';
import { ts } from './utils';
import { useController } from './hooks/useController';
import { style as s } from './DocumentsCard.style';
import { MissingDocumentModal } from '../MissingDocumentModal';

export const DocumentsCard = (props) => {
  const {
    type,
    notPreferred,
    missingCount,
    uploadedCount,
    documents,
    areGroupDocsReady,
    invalidDocuments,
    uploadedDocuments,
    requisitionStatus,
    areGroupDocsApproved,
    ...contentProps
  } = props;
  const {
    cardData,
    displayUploadedFilesAlert,
    displayMissingFilesAlert,
  } = useController({
    type,
    documents,
    notPreferred,
    missingCount,
    uploadedCount,
    areGroupDocsReady,
    areGroupDocsApproved,
    uploadedDocuments,
    requisitionStatus,
  });
  const { isOpen, onOpen, onClose } = useModalDisclosure();

  const {
    title,
    isPreferred,
    description,
    PendingImage,
    continuesPath,
    CompleteImage,
    uploadDocumentText,
    isStatusWarning,
    showPendingImage,
    showCompleteImage,
    showIDontHaveItButton,
    showUploadDocumentButton,
    showEditUploadedDocumentButton,
  } = cardData;

  const bodyStyle = isStatusWarning ? s.pendingBody : s.body;

  return (
    <Card {...s.card} {...contentProps}>
      <MissingDocumentModal
        isOpen={isOpen}
        onClose={onClose}
        type={type}
      />
      {isPreferred && (
        <Tag {...s.preferredTag}>
          {ts('generic.preferred')}
        </Tag>
      )}
      {isStatusWarning && (
        <Tag {...s.pendingTag}>
          {ts('generic.warning')}
        </Tag>
      )}
      <CardBody {...bodyStyle}>
        <Box boxSize="20">
          {showPendingImage && <PendingImage width="100%" height="100%" data-testid="pending-image" />}
          {showCompleteImage && <CompleteImage width="100%" height="100%" data-testid="complete-image" />}
        </Box>
        <Text {...s.title}>{title}</Text>
        <Text {...s.text}>{description}</Text>
        {isStatusWarning && (
          <Alert {...s.pendingAlert}>
            {ts('generic.errorCount', { count: invalidDocuments })}
          </Alert>
        )}
        {displayUploadedFilesAlert && (
          <Alert {...s.completeAlert}>
            <AlertIcon />
            {ts('generic.documentCount', { count: uploadedCount })}
          </Alert>
        )}
        {displayMissingFilesAlert && (
          <Alert {...s.pendingAlert}>
            <AlertIcon />
            {ts('generic.missingDocuments', { count: missingCount })}
          </Alert>
        )}
        {showUploadDocumentButton && (
          <Button
            {...s.button}
            as={Link}
            to={continuesPath}
          >
            {uploadDocumentText}
          </Button>
        )}
        {showIDontHaveItButton && (
          <Button
            onClick={onOpen}
            variant="ghost"
          >
            {ts('generic.iDoNotHaveIt')}
          </Button>
        )}
        {
          showEditUploadedDocumentButton && (
            <Button
              as={Link}
              to={continuesPath}
              rightIcon={<EditIcon color="blue.500" />}
              {...s.completeButton}
              variant="subtle"
              colorScheme="green"
            >
              {ts('generic.documentCount', { count: uploadedDocuments })}
            </Button>
          )
        }
      </CardBody>
    </Card>
  );
};
